<app-label-value label="Société" [value]="contract().companyId | companyName"></app-label-value>

<app-label-value label="Contrat" [value]="contract().contractType"></app-label-value>

<app-label-value
  class="col-sm"
  label="Début"
  [value]="contract().startDate | date"
></app-label-value>
@if (contract().contractType !== 'CDI') {
  <app-label-value class="col-sm" label="Fin" [value]="contract().endDate | date"></app-label-value>
}
<app-label-value label="Pde essai" [value]="trialPeriodDuration"></app-label-value>

@if (contract().jobId) {
  <app-label-value
    [label]="contract().jobId | jobName: jobTypes"
    [value]="contract().qualificationLevel"
  ></app-label-value>
}

@if (contract().grossHourlySalary) {
  <app-label-value
    [reverse]="true"
    label="/h"
    [value]="contract().grossHourlySalary | currency: 'EUR' : 'symbol' : '1.2-2'"
  ></app-label-value>
}
@if (contract().contractType === 'CDD R' || contract().contractType === 'CDD RST') {
  <section class="indent">
    <app-label-value label="Remplacement"> </app-label-value>

    <app-label-value
      class="col-sm"
      label="Nom"
      [value]="$safeNavigationMigration(contract().replacement?.lastName)"
    ></app-label-value>
    <app-label-value
      class="col-sm"
      label="Prénom"
      [value]="$safeNavigationMigration(contract().replacement?.firstName)"
    ></app-label-value>
    <app-label-value
      label="Motif"
      [value]="$safeNavigationMigration(contract().replacement?.reason)"
    ></app-label-value>
  </section>
}
